import { ReactNode } from "react";

interface LegalPageProps {
  title: string;
  updated: string;
  children: ReactNode;
}

export function LegalPage({ title, updated, children }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-2">
          <a href="/" className="text-sm text-gray-500 hover:text-gray-700">
            ← Back to home
          </a>
        </div>
        <h1 className="mt-6 text-4xl font-semibold tracking-tight text-gray-900">
          {title}
        </h1>
        <p className="mt-2 text-sm text-gray-400">Last updated: {updated}</p>
        <div className="mt-12 prose prose-gray max-w-none">{children}</div>
      </div>
      <footer className="border-t border-gray-100 py-8">
        <div className="max-w-3xl mx-auto px-6 flex justify-between items-center text-sm text-gray-400 flex-wrap gap-3">
          <span>© 2026 Ammayum Kunjum. Made in Malappuram, Kerala.</span>
          <span className="flex gap-4">
            <a href="/legal/privacy" className="hover:text-gray-600">
              Privacy Policy
            </a>
            <a href="/legal/terms" className="hover:text-gray-600">
              Terms of Service
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
